module.exports = __webpack_public_path__ + "img/HR38182927268.75fab375.png";